import axios from "axios";
import BaseService from "./baseService";

class ServiceSupplierProfileRemindersController extends BaseService {
  async getLacking() {
    const response = await axios.get("/api/supplierProfileReminders/lacking");
    return response.data;
  }

  async sendReminders(supplierIds) {
    const body = Array.isArray(supplierIds) && supplierIds.length ? { supplierIds } : {};
    const response = await axios.post("/api/supplierProfileReminders/send", body);
    return response.data;
  }

  async unsubscribeEmailNotifications({ p, s }) {
    const response = await axios.post(`/api/organizations/superadmin/supplier-profile-reminder/unsubscribe/${p}/${s}`);
    return response.data;
  }

  async fetchStatus({ p, s }) {
    const response = await axios.get(`/api/organizations/superadmin/supplier-profile-reminder/unsubscribe/status/${p}/${s}`);
    return response.data.status;
  }
}

export const ServiceSupplierProfileReminders = new ServiceSupplierProfileRemindersController();
